import { IEirSalesSaveEmailPayload } from "@modules/eirSalesFacade/interfaces/payloads/IEirSalesSaveEmailPayload";

export const mapEirSalesSaveEmailPayload = (email: string, eircode: string): IEirSalesSaveEmailPayload => ({
    email,
    eircode,
});
